//@ts-nocheck
export const drawerWidth = 240;